import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Ban, Wrench, Layers, Rocket } from 'lucide-react';

const PhilosophySection = () => {
  const { t } = useLanguage();

  const principles = [
    { key: 'noHype', icon: Ban, number: '01' },
    { key: 'tool', icon: Wrench, number: '02' },
    { key: 'architecture', icon: Layers, number: '03' },
    { key: 'production', icon: Rocket, number: '04' },
  ];

  return (
    <section id="philosophy" className="py-32 lg:py-40 bg-zinc-950 relative overflow-hidden">
      {/* Background text */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 text-[15vw] font-extralight text-zinc-900/30 whitespace-nowrap select-none pointer-events-none">
        PHILOSOPHY
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20 lg:mb-24">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent" />
            <span className="text-xs tracking-[0.3em] text-cyan-400 uppercase font-medium">Approach</span>
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent" />
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-extralight text-white leading-tight">
            {t.philosophy.title}
          </h2>
        </div>

        {/* Principles Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-1">
          {principles.map(({ key, icon: Icon, number }, index) => (
            <div 
              key={key}
              className="group relative p-8 lg:p-10 bg-black border border-zinc-900 hover:border-zinc-800 transition-all duration-500"
            >
              {/* Number watermark */}
              <div className="absolute top-4 right-4 text-5xl font-extralight text-zinc-900 group-hover:text-zinc-800 transition-colors duration-500">
                {number}
              </div>

              {/* Hover accent */}
              <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-cyan-400 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />

              <div className="relative z-10">
                <div className="w-12 h-12 mb-8 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-zinc-600 group-hover:text-cyan-400 transition-colors duration-500" />
                </div>
                
                <h3 className="text-lg font-medium text-white mb-4 group-hover:text-cyan-50 transition-colors">
                  {t.philosophy.principles[key].title}
                </h3>
                
                <p className="text-sm text-zinc-500 leading-relaxed group-hover:text-zinc-400 transition-colors">
                  {t.philosophy.principles[key].description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
